export default {
  upercase: {
    textTransform: 'uppercase'
  },
  lowercase: {
    textTransform: 'lowercase'
  },
  capitalize: {
    textTransform: 'capitalize'
  },
  black: {
    color: '#000'
  },
  gray40: {
    color: '#666'
  },
  gray20: {
    color: '#333'
  },
  graySoft: {
    color: '#d8d8d8'
  },
  orange: {
    color: '#c94'
  },
  white: {
    color: '#fff'
  },
  green: {
    color: '#5ca70a'
  },
  italic: {
    fontStyle: 'italic'
  },
  fontSize10: {
    fontSize: '10px'
  },
  fontSize13: {
    fontSize: '13px'
  },
  fontSize16: {
    fontSize: '16px'
  },
  fontSize18: {
    fontSize: '18px'
  },
  fontSize20: {
    fontSize: '20px'
  },
  fontDroidSerif: {
    fontFamily: "'Droid Serif'"
  },
  bold: {
    fontWeight: 'bold'
  },
  fontWeight300: {
    fontWeight: '300'
  }
};
